/** Przegląd tygodniowy (Faza 6) — kształty z `app/api/review.py`. */

export type ReviewStepStatus = "todo" | "current" | "done" | "skipped";

export interface ReviewStepRef {
  key: string;
  number: number;
  title: string;
}

export interface ReviewStepProgress extends ReviewStepRef {
  status: ReviewStepStatus;
}

export interface ReviewCursorItem {
  id: string;
  title: string;
  [extra: string]: unknown;
}

export interface ReviewCursor {
  index: number;
  total: number;
  current: ReviewCursorItem | null;
  remaining: number;
  items: ReviewCursorItem[];
}

export interface ReviewStats {
  start: Record<string, number>;
  end: Record<string, number>;
  delta: Record<string, number>;
  steps_done: number;
  steps_skipped: string[];
  duration_min: number | null;
}

export interface ReviewSessionState {
  id: string;
  status: "active" | "finished" | "abandoned";
  space_scope: string | null;
  started_at: string | null;
  finished_at: string | null;
  current_step: string;
  step_number: number;
  step_count: number;
  step_title: string;
  steps: ReviewStepProgress[];
  cursor: ReviewCursor;
  payload: Record<string, unknown>;
  stats: ReviewStats;
}

export interface ReviewLastFinished {
  id: string;
  finished_at: string | null;
  space_scope: string | null;
  stats: ReviewStats;
}

export interface ReviewState {
  active: boolean;
  session: ReviewSessionState | null;
  last_finished: ReviewLastFinished | null;
  steps: ReviewStepRef[];
  opening_message: string | null;
}

/** Etykiety liczników ze statystyk (klucze z `review_service.counters`). */
export const COUNTER_LABELS: Record<string, string> = {
  inbox: "inbox",
  next_actions: "next",
  projects_active: "projekty",
  projects_stalled: "bez next action",
  waiting: "waiting",
  someday: "someday",
};
